@if (!navItem.externalLink) { @if (navItem.url) {
<a
  class="nav-link"
  [routerLink]="[navItem.url]"
  routerLinkActive="active"
  [routerLinkActiveOptions]="{ exact: navItem.exactMatch || false }"
>
  <ng-container [ngTemplateOutlet]="linkContent"></ng-container>
</a>
} } @else {
<a class="nav-link" (click)="openLink(navItem.url)">
  <ng-container [ngTemplateOutlet]="linkContent"></ng-container>
</a>
}

<ng-template #linkContent>
  @if (navItem.icon) {
  <mat-icon [svgIcon]="navItem.icon" class="nav-link-icon"></mat-icon>
  }
  <span class="nav-link-title">{{ navItem.title | translate }}</span>
</ng-template>
